import { render, staticRenderFns } from "./HousesList.vue?vue&type=template&id=0eed1472&scoped=true&"
import script from "./HousesList.vue?vue&type=script&lang=js&"
export * from "./HousesList.vue?vue&type=script&lang=js&"
import style0 from "./HousesList.vue?vue&type=style&index=0&id=0eed1472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eed1472",
  null
  
)

export default component.exports